export const htmlTreeDownload = `poke-css/
    |-- main/
    |   |-- main.scss / main.css`


export const htmlTreeNpm = `node_modules/
    |-- poke-css/
    |   |-- main/
    |       |-- main.scss / main.css`
